'use client';
import React from 'react';

export default function PrimaryDiv({children}) {
	return (
		<div className=''>
			{children}
		</div>
	)
}
